import { lightPalette } from '../palette'

export const MuiPaper = {
  styleOverrides: {
    root: {
      backgroundColor: lightPalette?.background?.default,
      border: '1px solid #d7d7d7',
      borderRadius: 6,
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '4px 0',
      },
      '& .MuiMenuItem-root': {
        color: lightPalette?.text?.main,
        padding: '11px 17px',
        '&:hover': {
          color: '#004744',
        },
        '&:selected': {
          color: '#004744',
        },
        fontSize: 12,
        fontWeight: '500',
        '& .MuiSvgIcon-root': {
          fontSize: 14,
        },
      },
    },
  },
  variants: [
    {
      props: {
        variant: 'primary',
      },
      style: {
        backgroundColor: lightPalette?.background?.default,
        borderRadius: 6,
        boxShadow:
          'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
          padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
          color: lightPalette?.text?.main,
          padding: '11px 17px',
          '&:hover': {
            color: '#004744',
          },
          '&:selected': {
            color: '#004744',
          },
          fontSize: 12,
          fontWeight: '500',
          '& .MuiSvgIcon-root': {
            fontSize: 14,
          },
        },
      },
    },
  ],
}
